import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackCopyWishListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackCopyWishList";

const useTrackCopyWishList = (
    parameters: TrackCopyWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.copyWishList, parameters, options);
};

export default useTrackCopyWishList;
